import script from "./SelectDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SelectDropdown.vue?vue&type=style&index=0&id=58ec4a9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ec4a9e"]])

export default __exports__